module.exports = __webpack_public_path__ + "assets/img/rediotherapy-patient-title.05eda5d9.png";